import { QueryClient } from '@tanstack/react-query';

import { getUserProductsQueryOptions } from '@/queries/products';
import { Product } from '@/queries/products/types';
import { setUserData } from '@/redux/slices/user/actions';
import store from '@/redux/store';
import { buildURL } from '@/shared/fetch';

const symbols: Record<string, string> = {
  usd: '$',
  eur: '€',
  gbp: '£',
  aud: 'AU$',
  cad: 'CA$',
  nzd: '$NZ',
};

export const getCurrencySymbol = (currency: string | null | undefined) => {
  return symbols[currency?.toLowerCase() ?? 'usd'] || '$';
};

export const formatPrice = (price: number) => {
  return (price / 100).toFixed(2).replace(/[.,]00$/, '');
};

export const parseBenefits = (product: Product | undefined) => {
  if (!product) return [];
  const rawBenefits = product.price.metadata?.benefits ?? product.metadata?.benefits;
  if (!rawBenefits) return [];
  try {
    const parsed: unknown = JSON.parse(rawBenefits);
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : [];
  } catch (error) {
    return [];
  }
};

export const handlePatchUserProductSuccess = (queryClient: QueryClient) => () => {
  queryClient.invalidateQueries({ queryKey: getUserProductsQueryOptions().queryKey });
  fetch(buildURL('/users/user'))
    .then((response) => (response.ok ? response.json() : Promise.reject(new Error('Failed to fetch user data'))))
    .then((user) => {
      store.dispatch(setUserData(user));
    })
    .catch((error) => {
      console.error(error);
    });
};
